import React from "react";

// Subtle radial accent glow + fine grain overlay. Render as the first child of a
// `relative overflow-hidden` section; keep the section's real content in a
// `relative z-10` wrapper so it always paints above this layer.
const GRAIN =
  'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27140%27 height=%27140%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%272%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url(%23n)%27/%3E%3C/svg%3E")';

export const SectionGlow = ({ position = "20% 0%", strength = 12 }) => (
  <>
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0"
      style={{ background: `radial-gradient(ellipse at ${position}, color-mix(in srgb, var(--accent-primary) ${strength}%, transparent), transparent 55%)` }}
    />
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 opacity-[0.035]"
      style={{ backgroundImage: GRAIN }}
    />
  </>
);

export default SectionGlow;
